

import { useEffect, useState } from "react";

// react-router components
import { useLocation } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import { Toaster } from 'react-hot-toast';
// routes
import Router from "./routes/index";
import { Provider } from "react-redux";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";

import store from "./redux/store/store";
// import axios from "axios";

import "react-toastify/dist/ReactToastify.css";
import { HelmetProvider } from "react-helmet-async";

// setting up base uri for axios
// axios.defaults.baseURL = process.env.REACT_APP_BASE_API_URL;

export default function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        {/* <Provider store={store}> */}
          <CssBaseline />
          <Router />
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Toaster position="top-center" />
          <CssBaseline />
        {/* </Provider> */}
      </ThemeProvider>
    </HelmetProvider>
  );
}
